import { createFileRoute } from "@tanstack/react-router";
import { AdminSupportSettingsPage } from "@/components/admin/pages/AdminSupportSettingsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/support/settings")({
  component: AdminSupportSettingsPage,
});
